var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-cont"},[_c('NavBar',{staticClass:"nav-bar"}),_c('div',{staticClass:"page-content"},[_c('Gallery',{ref:"mainGallery",staticClass:"gallery",attrs:{"getWindowContent":_vm.getWindowContent}}),_c('Uploader')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }